import * as particles from "@pixi/particle-emitter";
import {Core} from "../ported/Base/Core";

import {TrailBehavior} from "./behaviors/TrailBehavior";
import {EMITTER_CREATURE_MERGE} from "./effects/VFXCreatureMerge";
import {EMITTER_SLOT_COINS, EMITTER_SLOT_STARS} from "./effects/VFXSlotCoins";
import {EMITTER_SLOT_DIAMONDS_DIAMONDS, EMITTER_SLOT_DIAMONDS_STARS} from "./effects/VFXSlotDiamonds";
import {EMITTER_SLOT_CREATURE_SMOKE, EMITTER_SLOT_CREATURE_STARS} from "./effects/VFXSlotCreature";
import {EMITTER_SLOT_SPINS_STARS} from "./effects/VFXSlotSpins";
import {UISprite} from "../ported/UI/Tools/Base/UISprite";
import {gsap} from "gsap";
import {UIText} from "../ported/UI/Tools/Base/UIText";

window.particles = particles; // XXX debug
particles.Emitter.registerBehavior(TrailBehavior);

async function emitParticles(emitter) {
    return new Promise((resolve) => emitter.playOnceAndDestroy(resolve));
}

export class VFX {
    Init(container) {
        this.container = container;
    }

    hideEffect(type, t = 0.3) {
        let effects = this.container.children.filter(vfx => vfx.type === type);
        if (t) {
            gsap.timeline().to(effects, {alpha: 0, duration: t});
        }
        else {
            for (let vfx of effects) vfx.visible = false;
        }
    }

    async creatureMerge(x, y) {
        let container = GameManager.gameView.vfxContainer;
        if (!this.container) return;

        let vfx = container.addChild(new PIXI.Container());
        vfx.type = "merge";
        vfx.scale.set(Core.app.renderer.resolution);
        vfx.position.set(x, y);

        let effects = [emitParticles(new particles.Emitter(vfx, EMITTER_CREATURE_MERGE))];
        this.creatureMergeTapChallengeProgress(x, y);

        await Promise.all(effects);
        container.removeChild(vfx);
    }

    async creatureMergeTapChallengeProgress(x, y) {
        if (!Core.UI.moneyButtons.tapChallengeMergeProgress.Active) return;
        // if (!Core.UI.tapChallenge.Active) return;
        let resolution = Core.app.renderer.resolution;
        let bounds = Core.UI.moneyButtons.tapChallengeMergeProgress.getBounds();
        bounds.x *= resolution;
        bounds.y *= resolution;
        bounds.width *= resolution;
        bounds.height *= resolution;

        const runParticle = async (particle) =>
            new Promise((resolve) => {
                let range = bounds.width * 0.05;
                let x = bounds.left + bounds.width * Core.UI.moneyButtons.tapChallengeMergeProgress.progress - range;
                x = Math.max(0, Math.min(bounds.width - range * 2, x)) + Math.random() * range * 2;
                gsap.timeline()
                    .delay(Math.random() * 0.3)
                    .timeScale(0.8 + Math.random() * 0.4)
                    .to(particle, { x: x, rotation: Math.PI * 2, duration: 1 }, 0)
                    .to(particle, { y: particle.y * 1.1, duration: 0.2 }, 0)
                    .to(particle, { y: bounds.bottom, duration: 0.8 }, 0.2)
                    .to(particle, { pixi: { scale: 0.5 }, duration: 0.2 })
                    .to(particle, { pixi: { scale: 0 }, duration: 0.2 })
                    .eventCallback("onComplete", resolve);
            });

        let vfx = this.container.addChild(new PIXI.Container()),
            particles = [];
        vfx.type = "merge-progress";

        for (let i = 0; i < 8; i++) {
            let particle = vfx.addChild(new UISprite("particles/shiny-star"));
            particle.tint = 0xccff99;
            particle.scale.set(0.2);
            particle.position.set(x, y);
            particles.push(runParticle(particle));
        }

        await Promise.all(particles);
        this.container.removeChild(vfx);
    }

    async tapChallengeTap(x, y) {
        if (!this.container) return;

        let vfx = this.container.addChild(new PIXI.Container());
        vfx.type = "tap-challenge";
        vfx.scale.set(Core.app.renderer.resolution);
        vfx.position.set(x, y);

        let effects = [emitParticles(new particles.Emitter(vfx, EMITTER_CREATURE_MERGE))];
        this.tapChallengeTapProgress(x, y);

        await Promise.all(effects);
        this.container.removeChild(vfx);
    }

    async tapChallengeTapProgress(x, y) {
        if (!Core.UI.moneyButtons.tapChallengeMergeProgress.Active) return;
        // if (!Core.UI.tapChallenge.Active) return;
        let resolution = Core.app.renderer.resolution;
        let bounds = Core.UI.tapChallenge._progressBar.getBounds();
        bounds.x *= resolution;
        bounds.y *= resolution;
        bounds.width *= resolution;
        bounds.height *= resolution;

        let vfx = this.container.addChild(new PIXI.Container()),
            particles = [];
        vfx.type = "tap-progress";

        let particle = vfx.addChild(new UISprite("particles/shiny-star"));
        particle.tint = 0xffff00;
        particle.scale.set(0.2);
        particle.position.set(x, y);

        let range = bounds.width * 0.05;
        x = bounds.left + bounds.width * 0.1 + bounds.width * (Core.UI.tapChallenge._progressBar.progress) - range;
        x = Math.max(0, Math.min(bounds.width - range * 2, x)) + Math.random() * range * 2;
        gsap.timeline()
            .delay(Math.random() * 0.3)
            .timeScale(0.8 + Math.random() * 0.4)
            .to(particle, { x: x, rotation: Math.PI * 2, duration: 1 }, 0)
            .to(particle, { y: particle.y * 1.1, duration: 0.2 }, 0)
            .to(particle, { y: bounds.bottom, duration: 0.8 }, 0.2)
            .to(particle, { pixi: { scale: 0.5 }, duration: 0.2 })
            .to(particle, { pixi: { scale: 0 }, duration: 0.2 })
            .eventCallback("onComplete", () => this.container.removeChild(vfx));
    }

    async slotCoins(n = 50) {

        let vfx = Core.UI.slots.vfxLayer.addChild(new PIXI.Container());
        vfx.scale.set(Core.app.renderer.resolution);
        vfx.position.set(Core.app.viewport.width * 0.5, Core.app.viewport.height * 0.5);
        vfx.type = "slot-coins";

        let effects = [
            emitParticles(
                new particles.Emitter(vfx, {
                    ...EMITTER_SLOT_STARS,
                    particlesPerWave: Math.max(1, Math.min(100, ~~(n / 2))),
                })
            ),
            emitParticles(
                new particles.Emitter(vfx, {
                    ...EMITTER_SLOT_COINS,
                    particlesPerWave: Math.max(1, Math.min(100, ~~n)),
                })
            ),
        ];

        await Promise.all(effects);
        Core.UI.slots.vfxLayer.removeChild(vfx);
    }

    async slotDiamonds(n = 2) {

        let vfx = Core.UI.slots.vfxLayer.addChild(new PIXI.Container());
        vfx.scale.set(Core.app.renderer.resolution);
        vfx.position.set(Core.app.viewport.width * 0.5, Core.app.viewport.height * 0.5);
        vfx.type = "slot-diamonds";

        let effects = [
            emitParticles(
                new particles.Emitter(vfx, {
                    ...EMITTER_SLOT_DIAMONDS_STARS,
                    particlesPerWave: Math.max(1, Math.min(100, ~~(n / 2))),
                })
            ),
            emitParticles(
                new particles.Emitter(vfx, {
                    ...EMITTER_SLOT_DIAMONDS_DIAMONDS,
                    particlesPerWave: Math.max(1, Math.min(100, ~~n)),
                })
            ),
        ];

        await Promise.all(effects);
        Core.UI.slots.vfxLayer.removeChild(vfx);
    }

    async slotSpins(machine) {
        let vfx = Core.UI.slots.vfxLayer.addChild(new PIXI.Container());
        vfx.scale.set(Core.app.renderer.resolution);
        vfx.position.set(Core.app.viewport.width * 0.5, Core.app.viewport.height * 0.5);
        vfx.type = "slot-spins";

        let star = vfx.addChild(new UISprite("particles/sparks-hit"));
        let spin = vfx.addChild(new UISprite("slots/item-spin"));

        [star, spin].forEach((item) => {
            item.scale.set(0);
            item.alpha = 0;
        });

        const wh = 220;

        let starRect = new PIXI.Rectangle(0, 0, wh, wh);
        let spinRect = starRect.clone().pad(-wh * 0.2);

        let starScale = Math.min(starRect.width / star.texture.width, starRect.height / star.texture.height);
        let spinScale = Math.min(spinRect.width / spin.texture.width, spinRect.height / spin.texture.height);

        let to = vfx.toLocal(machine.spinsScale.getGlobalPosition());

        let showParticles = async () => {
            let container = vfx.addChild(new UISprite(""));
            container.y = to.y;
            container.scale.set(Math.min(wh / EMITTER_SLOT_SPINS_STARS.spawnRect.w, wh / EMITTER_SLOT_SPINS_STARS.spawnRect.h));

            let config1 = { ...EMITTER_SLOT_SPINS_STARS, scale: { start: 0.1, end: 0.1, minimumScaleMultiplier: 1 } };
            let config2 = {
                ...EMITTER_SLOT_SPINS_STARS,
                scale: { start: 1, end: 0, minimumScaleMultiplier: 1 },
                maxParticles: 1,
                spawnType: "point",
                startRotation: { min: 10, max: 10 },
            };

            await Promise.all([
                emitParticles(new particles.Emitter(container, particles.upgradeConfig(config1, "particles/shiny-star"))),
                emitParticles(new particles.Emitter(container, particles.upgradeConfig(config2, "particles/shiny-star"))),
            ]);

            Core.UI.slots.vfxLayer.removeChild(vfx);
        };

        gsap.timeline()
            .to(star, { rotation: Math.PI * 2, duration: 2 }, 0)
            .to(star, { pixi: { scale: starScale }, alpha: 1, duration: 1 }, 0)
            .to(spin, { pixi: { scale: spinScale }, alpha: 1, duration: 1 }, 0)
            .to(
                spin,
                {
                    y: to.y,
                    pixi: { scale: spinScale * 0.3 },
                    alpha: 0,
                    duration: 0.5,
                    onStart: () => (star.visible = false),
                    onComplete: () => showParticles(),
                },
                1.5
            );
    }

    async slotCreature(creatureId) {
        Core.Audio.Play("SpinWinComboCreature");

        let vfx = Core.UI.slots.vfxLayer.addChild(new PIXI.Container());
        vfx.scale.set(Core.app.renderer.resolution);
        vfx.position.set(Core.app.viewport.width * 0.5, Core.app.viewport.height * 0.5);
        vfx.type = "slot-creature";

        let star = vfx.addChild(new UISprite("particles/sparks-hit"));
        let creature = vfx.addChild(new UISprite(`creatures/${creatureId}`));
        let box = vfx.addChild(new UISprite("box"));

        [star, creature, box].forEach((item) => {
            item.scale.set(0);
            item.alpha = 0;
        });

        const wh = 220;

        let starRect = new PIXI.Rectangle(0, 0, wh, wh);
        let creatureRect = starRect.clone().pad(-wh * 0.2);
        let boxRect = starRect.clone().pad(-wh * 0.2);

        let starScale = Math.min(starRect.width / star.texture.width, starRect.height / star.texture.height);
        let creatureScale = Math.min(creatureRect.width / creature.texture.width, creatureRect.height / creature.texture.height);
        let boxScale = Math.min(boxRect.width / box.texture.width, boxRect.height / box.texture.height);

        let showParticles = () => {
            star.visible = false;
            creature.visible = false;

            box.scale.set(boxScale);
            box.alpha = 1;

            let config = particles.upgradeConfig(EMITTER_SLOT_CREATURE_SMOKE, "particles/smoke");
            emitParticles(new particles.Emitter(vfx, config));

            config = particles.upgradeConfig(EMITTER_SLOT_CREATURE_STARS, "particles/star");
            emitParticles(new particles.Emitter(vfx, config));
        };

        gsap.timeline()
            .to(star, { rotation: Math.PI, pixi: { scale: starScale }, alpha: 1, duration: 1 }, 0)
            .to(creature, { pixi: { scale: creatureScale }, alpha: 1, duration: 1, onComplete: () => showParticles() }, 0)
            .to(box, { x: Core.app.viewport.width, y: -Core.app.viewport.height * 0.2, duration: 1 }, 1.8)
            .eventCallback("onComplete", () => Core.UI.slots.vfxLayer.removeChild(vfx));
    }

    async newCreatureDiamond({ x, y, scale } = Core.UI.newCreature.diamondGlobalParams) {
        let target = Core.UI.moneyButtons.hardBtn.diamondGlobalParams;
        let vfx = this.container.addChild(new UISprite("ico-diamond"));
        vfx.type = "creature-diamond";
        vfx.scale.set(scale);
        vfx.position.set(x, y);
        gsap.timeline()
            .set(vfx, { x, y, pixi: { scale } })
            .to(vfx, { x: target.x, y: target.y, pixi: { scale: target.scale * 1.2 }, duration: 0.8 })
            .to(vfx, { pixi: { scale: target.scale }, duration: 0.2 })
            .eventCallback("onComplete", () => this.container.removeChild(vfx));
    }

    async newCreatureNextEpoch(sourceView, epochData) {
        // No animation for boss
        if (!epochData.nextEpochs || !epochData.nextEpochs.length) return;

        // No animation if epoch button is not visible
        let target = Core.UI.game.rightPanel.epochsList.items.find((item) => item.epoch.id === epochData.id);
        if (!target || !target.activeInHierarchy) return;

        let vfx = this.container.addChild(new UISprite(`creatures/${epochData.creatures[0]}`));
        vfx.type = "creature-epoch";

        let { a, tx, ty } = sourceView.sprite.transform.worldTransform;
        a *= Core.app.renderer.resolution;
        tx *= Core.app.renderer.resolution;
        ty *= Core.app.renderer.resolution;

        vfx.scale.set(0);
        vfx.alpha = 0;
        vfx.position.set(tx, ty);

        let bounds = target.getBounds();
        let x = (bounds.x + bounds.width * 0.5) * Core.app.renderer.resolution;
        let y = (bounds.y + bounds.height * 0.5) * Core.app.renderer.resolution;
        gsap.timeline()
            .delay(0.3)
            .to(vfx, { pixi: { scale: a, alpha: 1 }, duration: 0.5 }, 0)
            .to(vfx, { pixi: { scale: a * 1.5 }, duration: 0.3 }, ">")
            .to(vfx, { pixi: { scale: a * 0.1 }, duration: 0.6 }, ">")
            .to(vfx, { pixi: { alpha: 0 }, duration: 0.1 }, ">")
            .to(vfx, { x, duration: 0.9, ease: "sine.out" }, 0.5)
            .to(vfx, { y, duration: 0.9, ease: "sine.in" }, 0.5)
            .eventCallback("onComplete", () => {
                this.container.removeChild(vfx);
            });
    }

    async tapChallengeStartBanner() {
        let tx = PIXI.utils.TextureCache["offers/ribbon"];
        if (!tx) return;
        let {width, height} = Core.app.viewport;
        let w = Core.app.viewport.width * 0.8;
        let h = w * tx.height / tx.width;
        let rect = new PIXI.Rectangle((width - w) * 0.5, height * 0.25, w, h);

        let vfx = new UISprite("offers/ribbon");
        vfx.fitRect(rect);
        vfx.pivot.y = height * 0.25 + rect.height;
        this.container.addChild(vfx);

        let txt = vfx.addChild(new UIText(Core.Localizator.Get("tap_challenge_title_info")));
        rect = vfx.getLocalBounds();
        rect.height *= 0.75;
        rect.pad(-rect.width * 0.2, 0);
        txt.fitLayout(rect);

        gsap.timeline()
            .set(vfx, {pixi: {pivotY: height * 0.5}}, 0)
            .to(vfx, { pixi: { pivotY: 0 }, duration: 0.5, ease: "back.out(1.7)"}, 0)
            .to(vfx, { pixi: { pivotY: height * 0.5 }, duration: 0.5, ease: "back.in(2.7)"}, "+=0.5")
            .eventCallback("onComplete", () => {
                this.container.removeChild(vfx);
            });
    }
}
